import type { CSSProperties } from 'react'

import { useT } from '@/shared/i18n'
import { cn } from '@/shared/lib/cn'
import type { SupportSeverity } from '@/shared/types/domain'

import { SEVERITY_GLYPH, SEVERITY_VAR, severityLabel } from '../severity'

export interface SeverityBadgeProps {
  severity: SupportSeverity
  className?: string
}

/** El semáforo de un issue. Misma caja que `StatusPill`, con los tonos de urgencia. */
export function SeverityBadge({ severity, className }: SeverityBadgeProps) {
  const t = useT()
  const token = SEVERITY_VAR[severity]
  const style: CSSProperties = {
    color: `hsl(var(${token}))`,
    backgroundColor: `hsl(var(${token}) / .12)`,
    borderColor: `hsl(var(${token}) / .3)`,
  }

  return (
    <span
      style={style}
      className={cn(
        'inline-flex h-5 items-center gap-1.5 whitespace-nowrap rounded-[var(--radius-control)] border px-1.5 text-2xs font-medium',
        className,
      )}
    >
      <span aria-hidden="true" className="num shrink-0 leading-none">
        {SEVERITY_GLYPH[severity]}
      </span>
      <span>{severityLabel(t, severity)}</span>
    </span>
  )
}
